const upperFirst = require('mn-utils/upperFirst');
const formatTime = require('mn-utils/formatTime');
const generatePDF = require('../../../../../utils/generatePDF');
const formatNumCurrency = require('../../../../../utils/formatNumCurrency');

module.exports = (data) => {
  const {
    refundId,
    fiatAmount,
    fiatCode,
    currencyAmount,
    currencyCode,
    assetAmount,
    assetCode,
    network,
    createdAt,
    hash,
    kind,
    email,
    status,
  } = data;

  const list = [
    ['Refund ID', refundId],
    !!kind && ['Refund type', kind],
    !!hash && ['Transaction hash', hash],
    ['Customer email', email],
    ['Amount (fiat)', (fiatAmount || currencyAmount) ? `${formatNumCurrency(fiatAmount || currencyAmount)} ${fiatCode || currencyCode}` : '-'],
    ['Amount (crypto)', assetAmount ? `${assetAmount} ${assetCode}` : '-'],
    ['Network', network],
    ['Refund date and time',
      createdAt
        ? formatTime(createdAt, '{dddd} {mmmm} {dd}, {yyyy} {HH}:{MM}')
        : '-',
    ],
    {separator: true},
    ['Status', upperFirst(status)],
  ].filter(el => el);

  return generatePDF(list);
};
